module.exports = __webpack_public_path__ + "img/cecilia-chacon.9d9b54b7.png";